(() => {
  const body = document.body;
  const sticky = document.querySelector('[data-pdp-sticky-purchase]');
  const primary = document.querySelector('[data-pdp-primary-purchase]');

  const headerCollapseAt = 200;
  const headerExpandAt = 80;
  let headerCompact = body.classList.contains('pdp-header-compact');

  const setHeaderState = () => {
    const scrollPosition = Math.max(0, window.scrollY);

    if (!headerCompact && scrollPosition >= headerCollapseAt) {
      headerCompact = true;
    } else if (headerCompact && scrollPosition <= headerExpandAt) {
      headerCompact = false;
    }

    body.classList.toggle('pdp-header-compact', headerCompact);
  };

  let rafPending = false;
  window.addEventListener('scroll', () => {
    if (rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(() => {
      setHeaderState();
      rafPending = false;
    });
  }, { passive: true });
  setHeaderState();

  document.querySelectorAll('.pdp-premium .pdp-section-header').forEach((header) => {
    const content = header.nextElementSibling;
    if (!content || !content.classList.contains('pdp-section-content')) return;

    content.classList.remove('open');
    const toggle = header.querySelector('.pdp-section-toggle');
    if (toggle) toggle.classList.remove('open');

    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'false');

    const sync = () => {
      header.setAttribute('aria-expanded', String(content.classList.contains('open')));
    };

    header.addEventListener('click', () => window.requestAnimationFrame(sync));
    header.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      header.click();
    });
  });

  if (sticky && primary && 'IntersectionObserver' in window) {
    const setSticky = (visible) => {
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      body.classList.toggle('pdp-sticky-visible', visible);
    };

    const observer = new IntersectionObserver((entries) => {
      const primaryVisible = entries[0] && entries[0].isIntersecting;
      setSticky(!primaryVisible);
    }, { rootMargin: '-70px 0px 0px', threshold: 0.05 });

    observer.observe(primary);

    const mainVariant = document.querySelector('.pdp-product-form input[name="id"]');
    const stickyVariant = sticky.querySelector('input[name="id"]');

    if (mainVariant && stickyVariant) {
      const syncVariant = () => {
        stickyVariant.value = mainVariant.value;
        stickyVariant.dispatchEvent(new Event('change', { bubbles: true }));
      };

      mainVariant.addEventListener('change', syncVariant);
      document.addEventListener('variant:change', syncVariant);
    }
  }

  const purchaseForm = document.querySelector('.pdp-product-form');
  const purchaseButton = purchaseForm && purchaseForm.querySelector('.pdp-btn-add-to-cart');
  const purchaseStatus = purchaseForm && purchaseForm.querySelector('.pdp-purchase__status');

  async function updateCartFallback() {
    const response = await fetch((window.routes && window.routes.cart_url) || '/cart.js', {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) return;
    const cartData = await response.json();
    document.querySelectorAll(
      '.cart-count-bubble span[aria-hidden="true"], .cart-count-bubble span:first-child, [data-cart-count]'
    ).forEach((element) => {
      element.textContent = cartData.item_count;
    });
    const bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.classList.remove('hidden');
  }

  async function addPrimaryProduct(event) {
    if (!purchaseButton || event.submitter !== purchaseButton) return;
    event.preventDefault();
    if (purchaseButton.disabled) return;

    const originalText = purchaseButton.textContent.trim();
    const cartUi = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const formData = new FormData(purchaseForm);

    if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
      formData.append('sections', cartUi.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }

    purchaseButton.disabled = true;
    purchaseButton.setAttribute('aria-busy', 'true');
    purchaseButton.textContent = 'Adding…';
    if (purchaseStatus) purchaseStatus.textContent = '';

    try {
      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this item.');
      }

      if (cartUi && typeof cartUi.renderContents === 'function') {
        cartUi.renderContents(result);
      } else {
        await updateCartFallback();
      }

      purchaseButton.textContent = 'Added ✓';
      if (purchaseStatus) purchaseStatus.textContent = 'Added to your cart.';
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: result }));

      window.setTimeout(() => {
        purchaseButton.disabled = false;
        purchaseButton.removeAttribute('aria-busy');
        purchaseButton.textContent = originalText;
      }, 1600);
    } catch (error) {
      purchaseButton.disabled = false;
      purchaseButton.removeAttribute('aria-busy');
      purchaseButton.textContent = originalText;
      if (purchaseStatus) purchaseStatus.textContent = error.message;
    }
  }

  if (purchaseForm) purchaseForm.addEventListener('submit', addPrimaryProduct);

  const mobileTrack = document.querySelector('.pdp-gal__mobile-track');
  if (mobileTrack) {
    mobileTrack.setAttribute('aria-label', 'Product images. Swipe to see more.');
  }
})();
